<form
  name="elasticControlForm"
  [formGroup]="elasticControlForm"
  novalidate
  class="flex flex-row space-x-2 items-center">
  <mat-slider
    disableTab
    class="dense-slider flex-1"
    [step]="constraint.step"
    [max]="constraint.max"
    [min]="constraint.min"
    formControlName="slider"
    tickInterval="auto">
  </mat-slider>

  <mat-form-field appearance="outline" class="micro-input no-subscript no-label">
    <input #elasticValueInput matInput type="number" formControlName="input" (focus)="elasticValueInput.select()" />
    <mat-error *ngIf="elasticControlForm.get('input').hasError('required')" i18n>Не должно быть пустым</mat-error>
    <mat-error *ngIf="elasticControlForm.get('input').hasError('min')" i18n
      >Минимальное значение – {{ elasticControlForm.get('input').getError('min').min }}</mat-error
    >
    <mat-error *ngIf="elasticControlForm.get('input').hasError('max')" i18n
      >Максимальное значение – {{ elasticControlForm.get('input').getError('max').max }}</mat-error
    >
    <mat-error
      *ngIf="
        !elasticControlForm.get('input').hasError('required') &&
        elasticControlForm.get('input').hasError('forbiddenStep')
      "
      i18n
      >Не кратно {{ elasticControlForm.get('input').getError('forbiddenStep').step }} от минимального размера</mat-error
    >
  </mat-form-field>
</form>
